import React from 'react';
import {connect} from 'react-redux';
import { Dropdown, DropdownMenu, DropdownToggle,DropdownItem } from 'reactstrap';
import DatePick from 'react-datepicker';
import ReactQueryParams from 'react-query-params';
import * as TextManager from "../modules/languages/TextManager";

import {fetchMainDashboardDataIfNeeded} from '../redux/actions/MainDashboardActions'
import {fetchCustomeraDataIfNeeded} from "../redux/actions/CustomersActions";
import {fetchManagersStatsDataIfNeeded} from '../redux/actions/ManagersStatsActions'
import {fetchEquipmentDataIfNeeded} from "../redux/actions/EquipmentActions";
import {fetchOrdersDataIfNeeded} from "../redux/actions/OrdersActions";
import {fetchChangeSimDataIfNeeded} from "../redux/actions/ChangeSimActions";
import {fetchAutoCustomeraDataIfNeeded} from "../redux/actions/AutoCustomersActions";

class DateSelector extends ReactQueryParams {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            //startDate: moment(),
            isOpen: false,
            items:[
                {key:'today',value: TextManager.getCurrentTextResource().Utils.Date.today},
                {key:'yesterday',value: TextManager.getCurrentTextResource().Utils.Date.yesterday},
                {key:'7d',value: TextManager.getCurrentTextResource().Utils.Date.d7},
                {key:'30d',value: TextManager.getCurrentTextResource().Utils.Date.d30},
                {key:'60d',value: TextManager.getCurrentTextResource().Utils.Date.d60},
                {key:'this_month',value: TextManager.getCurrentTextResource().Utils.Date.this_month},
                {key:'last_month',value: TextManager.getCurrentTextResource().Utils.Date.last_month},
                {key:'last_6_months',value: TextManager.getCurrentTextResource().Utils.Date.last_6_months},
                {key:'last_12_months',value: TextManager.getCurrentTextResource().Utils.Date.last_12_months},
                //{key:'life_time',value: TextManager.getCurrentTextResource().Utils.Date.life_time}
            ],
            startDate: null,
            endDate: null
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange({startDate, endDate}) {
        startDate = startDate || this.state.startDate;
        endDate = endDate || this.state.endDate;

        if (startDate.isAfter(endDate)) {
            endDate = startDate
        }

        this.setState({startDate, endDate});
        //this.props.onChange({start: startDate, end: endDate});
    }

    handleChangeStart = (startDate) => this.handleChange({startDate});

    handleChangeEnd = (endDate) => this.handleChange({endDate});

    customRange = () => {

        if(this.state.startDate !== null && this.state.endDate !== null) {
            this.setQueryParams({
                date: 'custom',
                startDate: this.state.startDate.format('YYYY-MM-DD')+"T00:00:00Z",
                endDate: this.state.endDate.format('YYYY-MM-DD')+"T00:00:00Z"
            });

            if(this.props.endpoint === "dashboard"){
                this.props.dispatch(fetchMainDashboardDataIfNeeded(this.queryParams));
            }
            else if(this.props.endpoint === 'customers') {
                this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
            }
            else if(this.props.endpoint === 'managers_stats') {
                this.props.dispatch(fetchManagersStatsDataIfNeeded(this.queryParams));
            }
            else if(this.props.endpoint === 'orders') {
                this.props.dispatch(fetchOrdersDataIfNeeded(this.queryParams));
            }
            else if(this.props.endpoint === 'change_sim') {
                this.props.dispatch(fetchChangeSimDataIfNeeded(this.queryParams));
            }
        }
    };

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    chooseItem(id){
        this.setQueryParams({
            date: id,
            startDate: '',
            endDate: ''
        });

        if(this.props.endpoint === "dashboard"){
            this.props.dispatch(fetchMainDashboardDataIfNeeded(this.queryParams));
        }
        else if(this.props.endpoint === 'customers') {
            this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
        }
        else if(this.props.endpoint === 'managers_stats') {
            this.props.dispatch(fetchManagersStatsDataIfNeeded(this.queryParams));
        }
        else if(this.props.endpoint === 'orders') {
            this.props.dispatch(fetchOrdersDataIfNeeded(this.queryParams));
        }
        else if(this.props.endpoint === 'change_sim') {
            this.props.dispatch(fetchChangeSimDataIfNeeded(this.queryParams));
        }
        else if(this.props.endpoint === 'equipments') {
            this.props.dispatch(fetchEquipmentDataIfNeeded(this.queryParams));
        }
        else if(this.props.endpoint === 'auto_stat') {
            this.props.dispatch(fetchAutoCustomeraDataIfNeeded(this.queryParams));
        }
    }

    render() {
        var date = this.queryParams.date;
        if (!date){
            date = 'this_month';
        }

        let dateName;

        let items = this.state.items;

        if(this.props.userData && this.props.userData.data && this.props.userData.data.userType !== undefined) {
            if(this.props.userData.data.isAdmin) {
                if(!items.find(a => a.key === 'life_time'))
                    items.push({key:'life_time',value: TextManager.getCurrentTextResource().Utils.Date.life_time});
            }
        }

        if(date !== 'custom') {
            for (var dateIndex in items) {
                if (items[dateIndex].key === date) {
                    dateName = items[dateIndex].value;
                }
            }
        }
        else {
            let start = this.queryParams.startDate;
            let end = this.queryParams.endDate;

            start = start.split('T')[0];
            end = end.split('T')[0];

            dateName = start + " / " + end;
        }

        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle
                    className="icon icon--right btn btn-outline-primary btn-sm"
                    tag="span"
                    onClick={this.toggle}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen}
                >
                    <p>
                        {dateName}
                    <svg width="24" height="24" viewBox="0 0 24 24" className="mdi-icon">
                        <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                    </svg>
                    </p>
                </DropdownToggle>
                <DropdownMenu className='dropdown__menu'>

                    {items.map((currItem, index) =>
                        <DropdownItem key={index} onClick={() => this.chooseItem(currItem.key)}>
                            {currItem.value}
                        </DropdownItem>
                        )
                    }

                    <DropdownItem divider/>
                    <div className='date-picker date-picker--interval' style={{padding: 0, marginLeft: '20px'}}>
                        <style>
                            {`
                                .react-datepicker-wrapper input {
                                  width:110px;
                                }
                            `}
                        </style>
                        <DatePick
                            selected={this.state.startDate}
                            selectsStart
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleChangeStart}
                            dateFormat='LL'
                            placeholderText={TextManager.getCurrentTextResource().Utils.from}
                        />
                    </div>

                    <div className='date-picker date-picker--interval' style={{paddingTop: '1em', marginLeft: '20px'}}>
                        <DatePick
                            selected={this.state.endDate}
                            selectsEnd
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleChangeEnd}
                            dateFormat='LL'
                            placeholderText={TextManager.getCurrentTextResource().Utils.to}
                        />
                    </div>

                    <DropdownItem key='1000' onClick={() => this.customRange()} style={{marginTop: '1em'}}>
                        {TextManager.getCurrentTextResource().Utils.apply}
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        date: state.mainDashboard.date,
        userData: state.userData
    };
};

export default connect(mapStateToProps)(DateSelector);